import { en } from "./en";
import { th } from "./th";

export const translations = {
  EN: en,
  TH: th,
};
